module.exports = __webpack_public_path__ + "img/logo@3x.981a9229.png";